<template>
  <b-collapse
    :visible="isCollapsed"
    :id="'parentNav-lvl-' + level + '-' + index"
    v-if="children"
  >
    <!-- v-if="
          ChildNav.hasOwnProperty('permissions') &&
          checkNavPermissions(
            ChildNav.permissions,
            ChildNav.cine_direct_sale,
            ChildNav.module_id,
            ChildNav
          )
        " -->

    <ul class="child-nav-list">
      <li v-for="(ChildNav, _index) in children" :key="_index">
        <!-- router-link-exact-active router-link-active -->
        <div
          v-if="
            ChildNav.children &&
            ChildNav.children.length > 0 &&
            ChildNav.isChildrenExist
          "
        >
          <div
            class="parent-nav"
            :class="ChildNav.isCollapsed ? null : 'collapsed'"
            :aria-expanded="ChildNav.isCollapsed ? 'true' : 'false'"
            :aria-controls="'parentNav-lvl-' + (level + 1) + '-' + _index"
            @click.prevent.stop="onHandleCollapsed(children, _index)"
          >
            <div :class="ChildNav.icon + ' nav-icon'"></div>

            <div class="nav-title">{{ $tc(ChildNav.name, 2) }}</div>
          </div>

          <sidebar-dropdown
            :children="ChildNav.children"
            :isCollapsed="ChildNav.isCollapsed"
            :index="_index"
            :level="level + 1"
            :onHandleCollapsed="onHandleCollapsed"
          />
        </div>

        <router-link
          v-else-if="
            ChildNav.hasOwnProperty('show')
              ? ChildNav.show
              : ChildNav.hasOwnProperty('ModuleId')
              ? ChildNav.ModuleId != 2
              : true
          "
          :to="ChildNav.url"
          @click.native="setCurrentSideNavRoute(ChildNav.url)"
          :title="ChildNav.name"
          :class="[
            ' ',
            getCurrentSideNavRoute && getCurrentSideNavRoute === ChildNav.url
              ? 'router-link-exact-active router-link-active'
              : '',
          ]"
        >
          <div class="d-flex">
            <img
              src="@/assets/img/icons/arrow-right.svg"
              height="auto"
              width="10"
              class="mr-2"
            />
            <span
              :style="
                ChildNav.hasOwnProperty('ModuleId')
                  ? ChildNav.ModuleId == '3'
                    ? 'color:red'
                    : ''
                  : ''
              "
            >
              {{ $tc(ChildNav.name, 2) }}
            </span>
          </div>
        </router-link>
      </li>
    </ul>
  </b-collapse>
</template>

<script>
import { checkAccessController, checkParentId } from "@/helper/AccessControl";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "sidebar-dropdown",
  props: {
    children: {
      type: Array,
      default: () => [],
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    level: {
      type: Number,
      default: 1,
    },
    onHandleCollapsed: {
      type: Function,
    },
  },
  data: function () {
    return {
      isCollapsed2: this.isCollapsed,
    };
  },
  computed: {
    ...mapGetters(["getCurrentSideNavRoute"]),
  },
  methods: {
    ...mapActions(["setCurrentSideNavRoute"]),
    checkChildrens(index, Nav) {
      return checkParentId(Nav);
    },
    checkNavPermissions: function (Nav, direct_sale_flag, module_id, nav1) {
      if (module_id) {
        return checkAccessController(module_id);
      } else {
        return true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Containers/sidebarDropdown.vue